import { ArrowRight } from '@untitledui/icons';

import { getEntityTypeConfig } from '../registry/entityTypeRegistry';
import { TimelineTab } from '../timeline';

interface RecentActivityPreviewProps {
  orgId: number;
  entityId: string;
  entityType: string;
  /** Max number of timeline items to show. */
  limit: number;
  /** Invoked when the user clicks "View all activity →". */
  onViewAll: () => void;
  /** Used to build the link's aria-label, e.g. "View all activity for Acme Inc". */
  displayName: string;
}

export function RecentActivityPreview({
  orgId,
  entityId,
  entityType,
  limit,
  onViewAll,
  displayName,
}: RecentActivityPreviewProps) {
  // Seed the entity type's registry timeline defaults so the preview mirrors
  // the full Activity tab. Critically, this carries includeAssociated through:
  // TimelineTab's internal fallback is `?? true`, which for email threads
  // would re-enable the association fan-out (the timeline flood) on the
  // record's default Overview tab. The registry config object is module-level,
  // so the reference is stable across renders.
  const timelineDefaults =
    getEntityTypeConfig(entityType).timelineConfig?.defaultFilters;

  return (
    <div className='space-y-3'>
      <TimelineTab
        key={entityId}
        orgId={String(orgId)}
        entityId={entityId}
        entityType={entityType}
        limit={limit}
        defaultFilters={timelineDefaults}
        hideHeader
        hideFilters
        noBorder
      />
      <button
        type='button'
        onClick={onViewAll}
        aria-label={`View all activity for ${displayName}`}
        className='inline-flex items-center gap-1 text-sm font-medium text-brand-secondary hover:text-brand-secondary_hover transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus-ring rounded'
      >
        View all activity
        <ArrowRight className='w-4 h-4' aria-hidden='true' />
      </button>
    </div>
  );
}
